import React from "react";
import { useNavigate } from "react-router-dom";
import { Clock, Lock, Headphones, Compass, ArrowLeft, ArrowRight } from "lucide-react";
import Logo from "./Logo";

const Intro = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-[#f8f7f2] p-3">
      <div className="w-full max-w-[702px] flex flex-col">
        <Logo />
        <div className="w-full bg-white rounded-lg shadow-sm border border-[#e7e6e3] flex-col justify-start items-start flex overflow-hidden">
          <div className="self-stretch p-4 justify-between items-center inline-flex">
            <div className="grow shrink basis-0 h-10 justify-start items-center gap-2 flex" />
            <div className="justify-start items-center gap-1 flex">
              <div className="w-8 h-8 bg-[#1b1a17] rounded-full border border-[#1b1a17] flex items-center justify-center">
                <div className="text-white text-base font-bold font-inter">1</div>
              </div>
              <div className="w-8 py-4 flex-col justify-start items-start gap-2.5 inline-flex">
                <div className="self-stretch h-px border border-[#1b1a17]" />
              </div>
              <div className="w-8 h-8 bg-white rounded-full border border-[#1b1a17] flex items-center justify-center">
                <div className="text-[#1b1a17] text-base font-bold font-inter">2</div>
              </div>
              <div className="w-8 py-4 flex-col justify-start items-start gap-2.5 inline-flex">
                <div className="self-stretch h-px border border-[#e7e6e3]" />
              </div>
              <div className="w-8 h-8 bg-white rounded-full border border-[#e7e6e3] flex items-center justify-center">
                <div className="text-[#7a7871] text-base font-bold font-inter">3</div>
              </div>
            </div>
            <div className="grow shrink basis-0 h-10 justify-end items-center gap-2 flex" />
          </div>
          <div className="self-stretch px-4 pb-3 flex-col justify-start items-center gap-2 flex">
            <div className="self-stretch text-center text-[#0a0a08] text-xl font-semibold font-inter">Welcome to Letter Atlas</div>
            <div className="self-stretch text-center text-[#7a7871] text-sm font-normal font-inter">Your personal newsletter curation, management, and summarization platform.</div>
          </div>
          <div className="self-stretch px-4 pb-4 flex-col justify-start items-start gap-3 flex">
            <div className="self-stretch grid grid-cols-2 gap-3">
              <div className="h-[110px] p-3 bg-[#fdf6e2] rounded-md border border-[#f5f4f4] flex-col justify-center items-center gap-2 inline-flex">
                <Clock className="w-5 h-5" />
                <div className="self-stretch text-center text-[#0a0a08] text-sm font-semibold font-inter">Save Time</div>
                <div className="self-stretch text-center text-[#0a0a08] text-xs font-medium font-inter">Get short summaries of newsletters</div>
              </div>
              <div className="h-[110px] p-3 bg-[#eaf3f9] rounded-md border border-[#f5f4f4] flex-col justify-center items-center gap-2 inline-flex">
                <Lock className="w-5 h-5" />
                <div className="self-stretch text-center text-[#0a0a08] text-sm font-semibold font-inter">Privacy First</div>
                <div className="self-stretch text-center text-[#0a0a08] text-xs font-medium font-inter">We never snoop on emails</div>
              </div>
            </div>
            <div className="self-stretch grid grid-cols-2 gap-3">
              <div className="h-[110px] p-3 bg-[#fef3ec] rounded-md border border-[#f5f4f4] flex-col justify-center items-center gap-2 inline-flex">
                <Headphones className="w-5 h-5" />
                <div className="self-stretch text-center text-[#0a0a08] text-sm font-semibold font-inter">Audio Summaries</div>
                <div className="self-stretch text-center text-[#0a0a08] text-xs font-medium font-inter">Listen on the go</div>
              </div>
              <div className="h-[110px] p-3 bg-[#f5f1f6] rounded-md border border-[#f5f4f4] flex-col justify-center items-center gap-2 inline-flex">
                <Compass className="w-5 h-5" />
                <div className="self-stretch text-center text-[#0a0a08] text-sm font-semibold font-inter">Discover</div>
                <div className="self-stretch text-center text-[#0a0a08] text-xs font-medium font-inter">Find newsletters you'll love</div>
              </div>
            </div>
          </div>
          <div className="self-stretch p-4 flex-col gap-3">
            <div className="text-center pb-4 text-[#7a7871] text-sm font-medium">Let's personalize your experience!</div>
            <div className="flex justify-center items-center">
              <button 
                onClick={() => navigate("/onboarding/select-categories")}
                className="px-6 py-2.5 bg-[#14997e] rounded-md justify-center items-center gap-2 flex hover:bg-[#128b73] transition-colors">
                <div className="text-[#f9f9f9] text-base font-medium font-inter">Next</div>
                <ArrowRight className="w-5 h-5 text-white" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Intro;
